function writeReferrerCookie(r) {
  document.cookie = `referrer=${parseInt(r, 10)}; path=/; max-age=31536000;`;
}

function rewriteTicketingLinks(code) {
  [...document.getElementsByTagName('a')].forEach((a) => {
    const href = a.getAttribute('href');
    if (href?.includes('https://ticketing.spyscape.com/') || href?.includes('https://spyscape.web.d1tix.com/')) {
      const joiner = href.includes('?') ? '&' : '?';
      a.setAttribute('href', `${href}${joiner}code=${code.toString()}`);
    }
  });
}

function rotChar(code, a) {
  return a + ((code - a + 13) % 26);
}

const LOWERA = 96;
const LOWERZ = LOWERA + 26;
const UPPERA = 65;
const UPPERZ = UPPERA + 26;

function rot13(ciphertext) {
  const plaintext = [];
  for (let i = 0; i < ciphertext.length; i++) {
    const code = ciphertext.charCodeAt(i);
    if (code >= LOWERA && code <= LOWERZ) {
      plaintext.push(rotChar(code, LOWERA));
    } else if (code >= UPPERA && code <= UPPERZ) {
      plaintext.push(rotChar(code, UPPERA));
    } else {
      plaintext.push(code);
    }
  }

  return String.fromCharCode(...plaintext);
}

function init() {
  const urlParams = new URLSearchParams(window.location.search);
  const referrer = urlParams.get('referrer');
  let promocode = urlParams.get('promocode') || '';
  const rotcode = urlParams.get('code') || '';

  if (rotcode.length > 0) {
    promocode = rot13(rotcode);
  }

  if (referrer || promocode) {
    writeReferrerCookie(referrer);
  }

  window.addEventListener('DOMContentLoaded', () => {
    if (referrer || promocode) {
      rewriteTicketingLinks(promocode);
    }
  });
}

init();
